import { analytics } from '@/lib/analytics'
import { PhotoFade } from '@/ui/core/block'
import { Button, ButtonText } from '@/ui/core/button'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { router } from 'expo-router'
import { View } from 'react-native'
import Images from '#/assets/images/image-map'
import { HomeBadges } from './PhotoBadge'

const HEIGHT = 300

/**
 * The visit slot with nothing in it, as a poster: the photograph is the whole card and the
 * words sit on it, NEXT VISIT, the headline, the one ask. The reward for having nothing to
 * do is the picture.
 */
export const NothingHero = () => {
	const book = () => {
		analytics.trackClick('scheduling-appointment-button')
		router.push('/schedule')
	}

	return (
		<View className="overflow-hidden rounded-note bg-blush" style={{ height: HEIGHT }}>
			<Image
				source={Images.SmileBite}
				style={{ width: '100%', height: '100%' }}
				contentFit="cover"
				contentPosition={{ left: '50%', top: '40%' }}
				transition={300}
			/>
			<PhotoFade />
			<HomeBadges />
			<View className="absolute bottom-[18px] left-[18px] right-[18px]">
				<VStack gap={6}>
					<Header variant="h7" tone="white">
						Next visit
					</Header>
					{/* Set solid. Display type in this app is set at or below its own size — the h1
					    and h2 tokens are both under it, the login screens are at forty on forty,
					    and the home tiles at twenty-four on twenty-four. Thirty-six on thirty-
					    eight was the one heading opening its lines rather than closing them, and
					    it is two lines on every screen where it appears. */}
					<Header variant="h2" tone="white" className="text-[36px] leading-[36px]">
						{'Nothing on\nthe books'}
					</Header>
				</VStack>
				<View className="mt-3.5">
					<Button variant="accent" fullWidth={false} onPress={book}>
						<ButtonText>Pick a Time</ButtonText>
					</Button>
				</View>
			</View>
		</View>
	)
}
